import Img_1_mob_1x from '../images/Dance-Styles/DS-IMG-1-mob-1x.webp';
import Img_2_mob_1x from '../images/Dance-Styles/DS-IMG-4-mob-1x.webp';
import Img_6_mob_1x from '../images/Dance-Styles/DS-IMG-6-mob-1x.webp';

export const filterDanceConfig = [
    {
        id: 'Special',
        title: 'Special Events',
        img: Img_6_mob_1x,
        category: [
            {
                name:'Social-Hustle'
            },
            {
                name:'Pre-Ballet'
            },
            {
                name:'Am. Cha-Cha'
            },
            {
                name:'Bachata'
            },
            {
                name:'Chicago Steppin'
            },
            {
                name:'Social Ballroom'
            },
        ]
    },
    {
        id: "Social",
        title: 'Social dancing',
        img: Img_1_mob_1x,
        category: [
            {
                name:'Argentine Tango'
            },
            {
                name:'Adult Ballet'
            },
            {
                name:'Am. Smooth Waltz'
            },
            {
                name:'Social-Hustle'
            },
            {
                name:'Pre-Ballet'
            },
            {
                name:'Am. Cha-Cha'
            },
            {
                name:'Bachata'
            },
            {
                name:'Chicago Steppin'
            },
            {
                name:'Social Ballroom'
            },
        ]
    },
    {
        id: "Advanced",
        title: 'Advanced ballroom',
        img: Img_2_mob_1x,
        category: [
            {
                name:'Argentine Tango'
            },
            {
                name:'Adult Ballet'
            },
            {
                name:'Am. Smooth Waltz'
            },
            {
                name:'Social-Hustle'
            },
            {
                name:'Pre-Ballet'
            },
            {
                name:'Am. Cha-Cha'
            },
            {
                name:'Bachata'
            },
            {
                name:'Chicago Steppin'
            },
            {
                name:'Social Ballroom'
            },
        ]
    },
    {
        id: 'Parties',
        title: 'Parties',
        img: Img_6_mob_1x,
        category: [
            {
                name:'Argentine Tango'
            },
            {
                name:'Adult Ballet'
            },
            {
                name:'Am. Smooth Waltz'
            },
            {
                name:'Social-Hustle'
            },
            {
                name:'Pre-Ballet'
            },
            {
                name:'Am. Cha-Cha'
            },
            {
                name:'Bachata'
            },
            {
                name:'Chicago Steppin'
            },
            {
                name:'Social Ballroom'
            },
        ]
    },
    
]
export const difficultyLevelConfig = [
    {
        id: 'All',
        name:'All',
    },{
        id: 'Newbie',
        name:'Newbie',
    },{
        id: 'Bronze',
        name:'Bronze',
    },{
        id: 'Silver',
        name:'Silver',
    },{
        id: 'Gold',
        name:'Gold',
    },
]